﻿import {
    Component, TemplateRef, ElementRef,
    OnInit, OnDestroy, OnChanges, DoCheck,
    Input, Output,
    //ChangeDetectionStrategy, ChangeDetectorRef,
    EventEmitter,
    ViewChild, ContentChild, SimpleChanges
} from '@angular/core';
import { LoggerService } from '../../../@core/services/logger-service';

export interface IDropDownItemOption {
    id: string;
    label: string;
}

@Component({
    selector: 'sk-inspector-column-filter-sort',
    templateUrl: './inspectorColumnFilterSort.html',
    styleUrls: ['./inspectorColumnFilterSort.scss'],
    providers: [],
    //changeDetection: ChangeDetectionStrategy.OnPush // DO NOT SET THIS AS ONPUSH
})
export class InspectorColumnFilterSortComponent
    implements OnInit, OnDestroy, OnChanges, DoCheck {

    hostWidth: number;

    @ContentChild('contentTemplate') contentTemplate: TemplateRef<any>;
    @ViewChild("filterInput", { read: ElementRef }) filterInput: ElementRef;

    @Input() desktopWidthThreshold: number = 1200;
    @Input() hideWhen: boolean = false;
    @Input() isLeftJustified: boolean = false;
    @Input() isRightJustified: boolean = false;

    @Input() filterEnabled: boolean = true;
    //@Input() onFilter = new EventEmitter();
    @Input() isFilterOn: boolean = false;
    // two way
    @Input() filterText: string = '';
    @Output() filterTextChange = new EventEmitter();
    //

    @Input() sortEnabled: boolean = true;
    @Output() onSort = new EventEmitter();
    //@Input() sortColumnDefault: string = null;
    //@Input() sortDirectionDefault: string = null;
    @Input() sortHandle: string = null;
    // two way
    @Input() sortDirection: string = null; // '+', '-', or null
    @Output() sortDirectionChange = new EventEmitter();
    //
    // two way
    @Input() sortColumn: string = null;
    @Output() sortColumnChange = new EventEmitter();
    //
    @Input() dropDownStoreId = '';
    @Input() showDropDownButton: boolean = false;
    @Input() dropDownItemOptions: IDropDownItemOption[] = []; 
    @Output() dropDownItemClick = new EventEmitter();   

    constructor(
        private elementRef: ElementRef
    ) {
    }

    ngOnInit() {
        // sizing from host
        // MUST be calculated up front ...
        //this.loggerService.logData(this.elementRef);
        const element = this.elementRef;
        const native = element.nativeElement;
        const parent = native.parentElement;
        //this.loggerService.logData(element, native, parent);
        const { offsetWidth, offsetHeight } = parent;
        this.hostWidth = offsetWidth;

        //// defaults
        //if (this.sortHandle === this.sortColumnDefault) {
        //    const sortColumn = this.sortColumn || this.sortColumnDefault;
        //    this.sortColumn = sortColumn;
        //    this.sortColumnChange.emit(sortColumn);

        //    const sortDirection = this.sortDirection;
        //    this.sortDirection = sortDirection;
        //    this.sortDirectionChange.emit(sortDirection);
        //}
    }

    ngDoCheck() {
        //this.loggerService.logData('ngDoCheck');
    }

    ngOnDestroy() {

    }

    showFilter() {
        this.isFilterOn = true;
        setTimeout(() => {
            this.filterInput.nativeElement.focus();
        }, 25);
    }

    hideFilter() {
        this.isFilterOn = false;
        this.updateFilterText('');
    }

    updateFilterText(newValue) {
        this.filterText = newValue;
        this.filterTextChange.emit(newValue);
    }

    inputWidth() {
        // this value must be explicit, with built in margin, etc
        let paddingWidth = 15;
        //if (this.sortEnabled) paddingWidth += 20;
        return `${this.hostWidth - paddingWidth}px`;
    }

    isSortColumnDirectionActive(direction: string) {
        if (this.sortColumn === this.sortHandle) {
            return this.sortDirection === direction;
        }
        else {
            return direction === null;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    updateSort() {
        let newColumn, newDirection;
        if (this.sortColumn !== this.sortHandle) {
            newColumn = this.sortHandle;
            newDirection = '+';
        }
        else {
            // cycle values: (null) => (+) => (-)
            if (this.sortDirection === null) {
                newColumn = this.sortColumn;
                newDirection = '+';
            }
            else if (this.sortDirection === '+') {
                newColumn = this.sortColumn;
                newDirection = '-';
            }
            else if (this.sortDirection === '-') {
                newColumn = this.sortColumn;
                newDirection = '+';
            }
        }

        this.sortDirection = newDirection;
        this.sortDirectionChange.emit(newDirection);

        this.sortColumn = newColumn;
        this.sortColumnChange.emit(newColumn);

        this.onSort.emit({
            key: this.sortHandle,
            val: this.sortDirection
        });
    }

    isBorderVisible() {
        return this.sortEnabled && this.sortHandle === this.sortColumn;
    }

    isTabletFormat() {
        //this.loggerService.logData(window.screen.width);
        const width = window.screen.width;
        if (width < this.desktopWidthThreshold) {
            return true;
        }
        return false;
    }

    emitClick(item: IDropDownItemOption) {
        if (item && this.showDropDownButton) {
           this.dropDownItemClick.emit(item.id);
        }
    }
}
